<template>
  <div style="height: 100%;">
    <el-header class="skill-group-content">
      <h3 class="title">
        <div class="block">
          <span>角色权限管理</span>
        </div>
      </h3>
    </el-header>
    <el-row type="flex" justify="end">
      <el-button
        type="info"
        icon="el-icon-plus"
        v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/role/editRole_post')"
        style="margin-bottom: 10px;"
        size="small"
        @click="createRole()"
      >新建角色</el-button>
    </el-row>
    <el-scrollbar style="height: calc(100% - 60px - 42px - 10px);">
    <el-table size="small" :data="rolePageData" style="width: 100%">
      <el-table-column prop="roleName" label="角色名称" width="180" align="center"></el-table-column>
      <el-table-column prop="roleType" label="角色类型" width="180" align="center"></el-table-column>
      <el-table-column prop="description" label="描述" align="left" header-align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" content="修改" placement="bottom">
          <el-button
            v-if="$authUtis.hasButtonAuth('aicc-bp', '/role/editRole_post')"
            @click="editRole(scope.row)"
            type="text"
            size="small"
          >
            <svg class="icon icon-bianji" aria-hidden="true">
              <use xlink:href="#icontable-bianji" />
            </svg>
          </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="删除" placement="bottom" v-if="scope.row.id !== defaultSysRoleId">
          <el-button
            type="text"
            v-if="$authUtis.hasButtonAuth('aicc-bp', '/role/deleteRole_delete')"
            @click="deleteRole(scope.row)"
            size="small"
          >
            <svg class="icon icon-delete" aria-hidden="true">
              <use xlink:href="#icontable-delete" />
            </svg>
          </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 底部分页栏 -->
    <el-row style="float:right;">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :page-size.sync="pageSize"
        :current-page.sync="pageNum"
        :total="total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-row>
    </el-scrollbar>
  </div>
</template>

<script>
import { deleteRoleById, listRolesPage, deleteAppRole } from '@/api/user'

export default {
  name: 'ListRole',
  data() {
    return {
      rolePageData: [],
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      defaultSysRoleId: this.$global.defaultRoleId
    }
  },
  props: {
    listRoleFlag: Boolean
  },
  components: {},
  mounted() {
    this._listRolesPage()
  },
  computed: {
    storeAppList() {
      return this.$store.state.user.appList
    }
  },
  methods: {
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      this._listRolesPage()
    },
    createRole() {
      const roleId = ''
      this.$store.commit('role/setCurRoleId', roleId)
      this.$emit('changeView', !this.listRoleFlag)
    },
    editRole(row) {
      this.$store.commit('role/setCurRoleId', row.id)
      this.$emit('changeView', !this.listRoleFlag)
    },
    deleteRole(row) {
      this.$confirm('是否删除此角色？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          deleteRoleById(row.id)
            .then(res => {
              if (res.code === 2000) {
                this._listRolesPage()
                this.$message.success(res.data)
                /** 通知其他应用删除角色数据 */
                if (this.storeAppList.length > 0) {
                  this.storeAppList.forEach((v) => {
                    deleteAppRole(v.appId, row.id).then(res => {
                      // TODO判断调用APP接口是否调用成功
                    })
                  })
                }
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    _listRolesPage() {
      listRolesPage({ pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
        if (res.code === 2000) {
          this.rolePageData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.skill-group-content {
  margin: 0;
  padding: 0;
}
.el-pagination {
  margin-top: 30px;
  margin-bottom: 20px;
}
</style>
